import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import uuid from 'uuid/v4';
import Course from './Course';
import TabHeader from './TabHeader';
import TabContent from './TabContent';
import TabContentItem from './TabContentItem';

function Gallery({ options: { tabs, source, campaign, medium, icon, limit, layout }, content, options }) {
  const [activeTab, setActiveTab] = useState(0);

  function defineLayout() {
    switch (layout) {
      case '1':
      default:
        return {
          renderer: Course,
          galleryProps: {
            id: 'featured-videos-widget',
          },
          tabItemProps: {
            className: 'align-center posts-row',
          },
          tabContentProps: {
            className: classnames({
              'no-scroll': options['mobile-layout'] === 'columns',
              'horizontal-scroll': options['mobile-layout'] === 'slider',
              [`columns-${options['mobile-columns']}`]: options['mobile-columns'] > 1,
            }),
          },
        };
    }
  }

  const rendererProps = defineLayout();

  return (
    <section {...rendererProps.galleryProps} className="widget">
      {options['hide-title'] !== 'true' && !options['custom-title'] && (
        <TabHeader
          tabs={tabs}
          activeTab={activeTab}
          maxItem={+limit}
          setActiveTab={setActiveTab}
        />
      )}
      {options['hide-title'] !== 'true' && options['custom-title'] && (
        <div className="section-title">
          <span className="label titles-color text-uppercase">
            {options['custom-title']}
          </span>
        </div>
      )}
      <TabContent {...rendererProps.tabContentProps}>
        {tabs.map((tab, index) => (
          <TabContentItem
            key={uuid()}
            title={tab}
            tabIndex={index}
            activeTab={activeTab}
            {...rendererProps.tabItemProps}
          >
            {content[tab]?.slice(0, limit).map((item) => (
              <rendererProps.renderer
                key={item._id} // eslint-disable-line no-underscore-dangle
                item={item}
                icon={icon}
                type={tab}
                source={source}
                campaign={campaign}
                medium={medium}
              />
            ))}
          </TabContentItem>
        ))}
      </TabContent>
    </section>
  );
}

Gallery.propTypes = {
  options: PropTypes.object,
  content: PropTypes.object,
};

export default Gallery;
